import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n, {
  rtl: true
});

const i18n = new VueI18n({
  locale: "es",
  fallbackLocale: "es",
  messages: {
    es: {
      message: require("@/constants/i18n/es/translations.json"),
      flag: require("@/assets/img/flags/es.svg")
    },
    en: {
      message: require("@/constants/i18n/en/translations.json"),
      flag: require("@/assets/img/flags/en.svg")
    }
  }
});
// Create VueI18n instance with options
export default i18n;
